import createRoute      from '@widesk-ui/tools/createRoute';
import ProductSaleModel from '@models/shop/ProductSaleModel';

export default createRoute.splitView('/product_sales', 'shop', 'ProductSaleSplitView', ProductSaleModel.localize('plural'));
